import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Check, CreditCard, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { Card, Loader } from "@/components/Common";

const SHARED = ["Fotografie", "Identificazione della pianta", "Anamnesi e risposte", "Analisi preliminare dell'AI", "Storico della pianta (se salvata)"];

export default function ConsultationRequest() {
  const { analysisId } = useParams();
  const [a, setA] = useState(null);
  const [consent, setConsent] = useState(false);
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { api.get(`/analyses/${analysisId}`).then(({ data }) => setA(data)); }, [analysisId]);
  if (!a) return <Loader />;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/consultations", { analysis_id: analysisId, consent_transfer: consent, message, phone });
      toast.success("Richiesta inviata alla Dott.ssa De Vanna");
      navigate("/consulenze");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5 px-5 py-6" data-testid="consultation-request-page">
      <div>
        <p className="eyebrow">Consulenza professionale</p>
        <h1 className="font-serif text-3xl font-semibold text-[#0D2517]">Dott.ssa Luigia De Vanna</h1>
        <p className="text-sm text-[#5b6b60]">Dottore Agronomo</p>
      </div>
      <Card testid="consultation-summary">
        <p className="text-sm font-semibold text-[#0D2517]">{a.species?.common_name} <span className="botanical text-[#B39257]">{a.species?.botanical_name}</span></p>
        <p className="text-xs text-[#5b6b60]">{a.photos?.length} foto · {a.result?.main_cause?.name || "causa non determinata dall'AI"}</p>
        <p className="mb-2 mt-4 text-xs font-semibold uppercase tracking-wider text-[#5b6b60]">Dati che verranno trasferiti</p>
        <ul className="space-y-1">{SHARED.map((s) => <li key={s} className="flex items-center gap-2 text-sm"><Check size={14} className="text-[#15803D]" />{s}</li>)}</ul>
      </Card>
      <textarea className="field min-h-[90px]" placeholder="Vuoi aggiungere qualcosa per la Dott.ssa? (facoltativo)" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="consultation-message" />
      <input className="field" placeholder="Telefono per eventuale contatto (facoltativo)" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="consultation-phone" />
      <label className="flex gap-3 rounded-xl border border-[#ddc69c]/70 bg-white p-4" data-testid="consultation-consent-label">
        <Checkbox checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5" data-testid="consultation-consent-checkbox" />
        <span className="text-sm">Acconsento al trasferimento di questi dati alla Dott.ssa Luigia De Vanna per la valutazione professionale del caso.</span>
      </label>
      <div className="flex items-center gap-3 rounded-xl border border-dashed border-[#C9A96E] bg-[#f8f3e9] p-4" data-testid="payment-placeholder">
        <CreditCard size={18} className="text-[#B39257]" />
        <p className="text-xs text-[#5b6b60]">Pagamento online non ancora attivo: le modalità e il costo della consulenza ti verranno comunicati dalla professionista.</p>
      </div>
      <button onClick={submit} disabled={!consent || busy} className="btn-primary w-full" data-testid="consultation-submit-button"><UserCheck size={16} /> INVIA RICHIESTA</button>
    </div>
  );
}
